module.exports = __webpack_public_path__ + "img/milovana-logo.f8a333d9.jpg";